import React, { useState } from "react";

interface PaginationProps {
  currentPage: number;
  nextPage: number | null;
  handlePageChange: (page: number) => void;
  loading?: number | null | boolean;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  nextPage,
  handlePageChange,
  loading
}) => {
  const [loadingButton, setLoadingButton] = useState<string | null>(null);

  const prevPageExists = currentPage > 1;
  const nextPageExists = nextPage !== null;
  const handlePrevClick = () => {
    setLoadingButton("prev");
    handlePageChange(currentPage - 1);
  };

  const handleNextClick = () => {
    setLoadingButton("next");
    handlePageChange(currentPage + 1);
  };

  return (
    <div className="geo-pagination-container">
      <button
        className="geo-pagination-btn arrow"
        onClick={handlePrevClick}
        disabled={!prevPageExists || loading ? true : false}
        style={{
          color: prevPageExists ? "#259fa5" : "#8B7F8F",
          cursor: prevPageExists ? "pointer" : "not-allowed"
        }}
      >
        <i className="fa fa-angle-left" style={{ fontWeight: 900 }}></i>
        <span style={{ marginLeft: 10 }}>
          {loadingButton === "prev" && loading && (
            <span className="fa fa-spinner fa-spin ws-color-grey"></span>
          )}{" "}
          Prev
        </span>
      </button>

      {/* <div className="pagination-numbers">
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            className={`geo-pagination-btn ${
              index + 1 === currentPage ? "active" : ""
            }`}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </button>
        ))}
      </div> */}
      <button
        className="geo-pagination-btn arrow"
        onClick={handleNextClick}
        disabled={!nextPageExists || loading ? true : false}
        style={{
          color: nextPageExists ? "#259fa5" : "#8B7F8F",
          cursor: nextPageExists ? "pointer" : "not-allowed",
          marginLeft: 12
        }}
      >
        <span className="ws-pagination-next">
          Next{" "}
          {loadingButton === "next" && loading && (
            <span className="fa fa-spinner fa-spin ws-color-grey"></span>
          )}
        </span>
        <i className="fa fa-angle-right" style={{ fontWeight: 900 }}></i>
      </button>
    </div>
  );
};

export default Pagination;
